/* eslint-disable prefer-const */
import { env } from 'next-runtime-env';
import NextImage, { ImageLoaderProps, ImageProps } from 'next/image';
import { ForwardedRef, forwardRef } from 'react';

const normalizeSrc = (src: string) => (src.startsWith('/') ? src.slice(1) : src);

export const cloudflareLoader = ({ src, width, quality }: ImageLoaderProps) => {
  let imageTransform = env('NEXT_PUBLIC_IMAGE_TRANSFORM') === 'true';
  let imageTransformUrl = env('NEXT_PUBLIC_IMAGE_TRANSFORM_URL');

  // Debug
  // imageTransform = true;
  // imageTransformUrl = 'https://web.dev.equinox-ccg.io/image-transform';

  const params = [`width=${width}`, 'format=auto'];
  if (quality) {
    params.push(`quality=${quality}`);
  }

  if (imageTransform) {
    // Custom image transform URL through Cloudflare Worker
    if (imageTransformUrl) {
      params.push(`image=${normalizeSrc(src)}`);
      const paramsString = params.join('&');

      return `${imageTransformUrl}/?${paramsString}`;
    }

    const paramsString = params.join(',');

    return `${process.env.NODE_ENV === 'development' ? 'https://www.altered.gg' : ''}/cdn-cgi/image/${paramsString}/${normalizeSrc(src)}`;
  }

  return src;
};

const Image = forwardRef((props: ImageProps, ref: ForwardedRef<HTMLImageElement>) => (
  <NextImage loader={cloudflareLoader} {...props} ref={ref} />
));

Image.displayName = 'Image';

export default Image;
